/**
 * Shared types and constants for search filters
 * This file has no dependencies on client-side hooks
 */

import type { CarType } from "@eurodrive/utils"

export type { CarType }
export type DealType = "new" | "used" | "leasing"

export interface SearchFilters {
  // Search query
  searchQuery: string

  // Core filters
  carType: CarType
  dealType: DealType
  selectedFeatures: string[]
  selectedCarTypes: string[]
  priceRange: [number, number]
  showDiscountsOnly: boolean

  // Selection filters
  selectedManufacturer: string
  selectedModel: string

  // Range filters
  yearFrom: string
  yearTo: string
  kmFrom: string
  kmTo: string
}

export const defaultSearchFilters: SearchFilters = {
  searchQuery: "",
  carType: "Premium",
  dealType: "new",
  selectedFeatures: [],
  selectedCarTypes: [],
  priceRange: [0, 0],
  showDiscountsOnly: false,
  selectedManufacturer: "",
  selectedModel: "",
  yearFrom: "",
  yearTo: "",
  kmFrom: "",
  kmTo: "",
}
